module.exports = __webpack_public_path__ + "img/peopleStart.dcf516ac.png";